<template>
  <div id="register" class="modal" ref="registrationm">
    <div class="modal-content">
      <h4>Register</h4>
      <p>Submit your email and we'll let you know when we go live</p>
      <span id="email-status"></span>
      <form id="signup_form">
        <div class="row">
          <div class="col s8">
            <div class="input-field">
              <label for="email" class='active'>Email</label>
              <input type="text" v-model="email"/>
            </div>
          </div>
          <div class="col s4">
            <a class="btn waves-effect waves-light" @click="submitRegistration">Sign up</a>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <a class="waves-effect waves-green btn-flat" @click="closeModal">Nevermind</a>
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import axios from 'axios'
export default {
  data () {
    return {
      email: '',
      modalElement: null
    }
  },
  computed: {
  },
  methods: {
    closeModal () {
      let modalInstance = M.Modal.getInstance(this.modalElement)
      modalInstance.close()
    },
    submitRegistration () {
      const formData = { email: this.email }
      axios.post(
        'https://10vhqv62hg.execute-api.us-east-1.amazonaws.com/prod/register/new',
        formData, {
          headers: {
            'Content-Type': 'application/json; charset=utf-8'
          }
        }).then(result => {
        this.closeModal()
        this.$router.push('/thanks')
      }).catch(error => {
        console.log(error)
        this.closeModal()
      })
    }
  },
  mounted () {
    this.modalElement = document.querySelector('#register')
    M.Modal.init(this.modalElement)
  }
}
</script>

<style>
</style>
